import { render, staticRenderFns } from "./AddSubordinate.vue?vue&type=template&id=4df9bdec&"
import script from "./AddSubordinate.vue?vue&type=script&lang=ts&"
export * from "./AddSubordinate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports